

export interface PaginationRequest {
  moduleId?: number;
  userId?: string;
  userModuleId?: number;
  page: number;
  pageSize: number;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  externalUserId?: string;
  organisationId?: number;
  filemakerUUID?: string;
  statuses?: string[];
}

export const getPaginationRequestInitialValue =
  (): PaginationRequest => {
    return {
      moduleId: 0,
      userId: "",
      userModuleId: 0,
      page: 0,
      pageSize: 0,
      search: "",
      sortOrder: "",
      statuses: [],
    };
  };